<template>
  <dialog-scroll
    :title="L10n('add-a-contact-to-email')"
    ref="dialog"
  >
    <el-form class="dialog-email-contact">
      <div class="row">
        <div class="col-12">
          <el-form-item
            :label="L10n('search')"
            class="material-style"
          >
            <el-select
              v-model="search"
              filterable
              reserve-keyword
              remote
              :placeholder="L10n('type-to-search')"
              :remote-method="remoteMethod"
              :loading="isLoading"
              @change="handleChange"
            >
              <el-option
                v-for="option in options"
                :key="option.id"
                :label="option.email"
                :value="option.email"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="col-12">
          <div class="dialog-email-contact__tag-wrap">
            <el-tag
              v-for="email in tags"
              :key="email"
              type="info"
              closable
              class="dialog-email-contact__tag"
              @close="handleCloseTag(email)"
            >
              {{email}}
            </el-tag>
          </div>
        </div>
      </div>
    </el-form>
    <template v-slot:footer>
      <div class="dialog-email-contact__footer-wrap">
        <button type="button" class="btn btn-mobile-full btn-size-s btn-white" @click="handleClose">
          {{L10n('close')}}
        </button>
        <button type="button" class="btn btn-mobile-full btn-size-s" style="margin-left: auto" :disabled="tags.length === 0" @click="handleClear">
          {{L10n('clear')}}
        </button>
        <button type="button" class="btn btn-mobile-full btn-size-s" @click="handleFinish">
          {{L10n('finish')}}
        </button>
      </div>
    </template>
  </dialog-scroll>
</template>

<script>
import { ServiceContacts } from '@/services/Contacts'
import { mergeFilters, makeFilter, notEquals, contains } from '@/utils/dynamic'

export default {
  name: 'DialogAddContacts',
  components: {
    'dialog-scroll': () => import(/* webpackChunkName: 'Dialogs' */ '../DialogScroll')
  },
  data () {
    return {
      isLoading: false,
      search: '',
      options: [],
      hashValues: {}
    }
  },
  computed: {
    tags () {
      return Object.keys(this.hashValues)
    }
  },
  methods: {
    remoteMethod (searchValue) {
      this.isLoading = false

      ServiceContacts
        .getAllDynamic({
          select: ['id,email'].join(','),
          filter: mergeFilters(
            makeFilter('email', null, notEquals),
            makeFilter('email', '', notEquals),
            makeFilter(['name', 'email'], searchValue, contains)
          ).join('&&'),
          take: 10
        })
        .then(({ data }) => {
          this.options = data.value
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleChange (email) {
      this.hashValues = {
        ...this.hashValues,
        [email]: email
      }
      this.search = ''
    },
    handleCloseTag (email) {
      const newHashValues = {
        ...this.hashValues
      }
      delete newHashValues[email]
      this.hashValues = newHashValues
    },
    show () {
      this.$refs['dialog'].show()
    },
    hide () {
      this.$refs['dialog'].hide()
    },
    clear () {
      this.hashValues = {}
    },
    handleClose () {
      this.hide()
    },
    handleClear () {
      this.clear()
    },
    handleFinish () {
      this.$emit('onComplete', this.tags)
      this.clear()
      this.hide()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .dialog-email-contact{
    &__tag-wrap{
      margin: 0 -1rem
    }
    &__tag{
      margin: 1rem
    }
    &__footer-wrap{
      display: flex
      margin: 0 1rem
      .btn{
        margin: 1rem
      }
    }
  }
</style>
